export const image_fit_contain_shop_id_list = new Set(['1450']);
